(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignGlance', campaignGlance);

    function campaignGlance() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * If in a clinic scope, the ID of the therapist user doing the editing.
                 */
                therapistId: '@',

                /**
                 * The episode template being edited or created.
                 */
                episodeModel: '=',

                /**
                 * A function(campaignId, episodeTemplate) to create the new episode template.
                 */
                saveEpisodeTemplate: '=',

                /**
                 * A function(campaignId, episodeTemplateId, episodeTemplate) to update the existing episode template.
                 */
                updateEpisodeTemplate: '=',

                /**
                 * A function(campaignId, episodeTemplateId) to delete the existing episode template.
                 */
                removeEpisodeTemplate: '=',

                /**
                 * If provided, a function(clinic, featureString) that answers whether the clinic has that feature flag enabled.
                 */
                hasClinicFeature: '=',

                /**
                 * If provided, an initialized config for choosing therapists to assign to the template; if not provided, no therapists can be assigned.
                 */
                therapistConfig: '=',

                /**
                 * If provided, an initialized config for choosing associates to assign to the template; if not provided, no associates can be assigned.
                 */
                associateConfig: '=',

                /**
                 * If provided, an initialized config for care groups; if not provided, no care groups can be assigned.
                 */
                careGroupConfig: '=',

                isTemplate: '='
            },
            controller: 'CampaignGlanceCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaign-glance/campaign-glance.tpl.html'
        };
    }
})();
